export default Object.freeze({
  CreateRequest: 1,
  ViewDetails: 2,
  CancelRequest: 3,
  CompleteRequestInformation: 4,
  ApproveRequest: 5,
  ExecuteTask: 6,
  SignDocument: 7,
  ReassignTask: 8,
  MassRequestsApprove: 9,
  Export: 10,
  MassRequestsReject: 11,
  EntityAdd: 12,
  EntityEdit: 13,
  EntityDelete: 14,
  EntityImport: 15,
  RejectRequest: 16, // Local command, no provided by API
  SetFavorite: 17, // Local command, no provided by API
  VoidRequest: 18,
  MassRequestsCancel: 19,
  MassRequestsVoid: 20,
  ActionCustomCommands: 21,
});
